export const floorMapping = {
  "piani-intermedi": "middle",
  "ultimo-piano": "top",
  "piano-terra": "ground",
};

const ALL_PROPERTY_TYPES = [
  "apartment",
  "studio",
  "duplex",
  "penthouse",
  "house",
  "country house",
  "country estate",
  "palace",
  "chalet",
  "bungalow",
  "villa",
  "townhouse",
];

export const PROPERTY_TYPE_MAP = {
  "Garage - Posti Auto": ["garage"],
  Uffici: ["office"],
  Negozi: ["retail", "warehouse", "other_commercial"],
  "Case - Appartamenti": (checkboxes) => {
    const allTypesSelected = checkboxes?.some(
      (item) => item.id === "TutteLeTipologie" && item.checked
    );

    if (allTypesSelected) {
      return ALL_PROPERTY_TYPES;
    } else {
      return checkboxes
        .filter((item) => item.checked && item.id !== "TutteLeTipologie")
        .flatMap((item) => {
          const typeMap = {
            Appartamento: ["apartment", "studio", "duplex"],
            AtticoMansarda: ["penthouse"],
            CasaIndipendente: [
              "house",
              "country house",
              "country estate",
              "palace",
              "chalet",
              "bungalow",
            ],
            Loft: ["studio"],
            RusticoCasale: ["country house", "country estate"],
            Villa: ["villa"],
            VillettaAschiera: ["townhouse"],
          };
          return typeMap[item.id] || [];
        });
    }
  },
};
